// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-tab-item{flex:1;display:flex;align-items:center;justify-content:center;box-sizing:border-box;font-size:.373333rem}[data-dpr=\"2\"] .v5-tab-item{font-size:.746667rem}[data-dpr=\"3\"] .v5-tab-item{font-size:1.12rem}.v5-tab-item.v5-tab-item-selected{color:#ff552e;border-bottom:.0533333333rem solid #ff552e}", ""]);
// Exports
module.exports = exports;
